export interface AnnouncementSchedule {
  id: string;
  startAt: Date;
  endAt: Date;
}

export const ANNOUNCEMENT_SCHEDULE: AnnouncementSchedule = {
  id: 'btos-price-revision-2026-08',
  startAt: new Date('2026-07-14T00:00:00+09:00'),
  endAt: new Date('2026-08-31T00:00:00+09:00')
};

export function isAnnouncementActive(schedule: AnnouncementSchedule, now: Date = new Date()): boolean {
  // return now >= schedule.startAt && now < schedule.endAt;
  // TODO 現状は手動で切り替える
  return false;
}
